import Live from './Live'

export default Live
